var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('notifications'),_c('confirmation-dialogues',{ref:"confirms"}),_c('important-notification'),_c('global-alerts',{ref:"alerts"}),_c('router-view',{key:_vm.$store.state.initTime}),_c('flood-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }